import React from "react"
import { Outlet, useParams } from "react-router-dom"
import { Loader } from "src/components/global/Loader"
import { ModuleErrors } from "src/components/ui/ModuleErrors"
import { useActions, useAppState } from "src/state"

export function SuperAdminTalentLayout() {

    const { talentId } = useParams()

    const { loading, currentItem, errors } = useAppState().users
    const { subscribeToItem, unsubscribeFromItem } = useActions().users

    React.useEffect(() => {
        subscribeToItem({ id: talentId });
        return () => {
            unsubscribeFromItem()
        }
    }, [talentId, subscribeToItem, unsubscribeFromItem])

    if (loading) return <Loader />
    if (!currentItem) return <Loader />

    return (
        <React.Fragment>
            <ModuleErrors errors={errors} />
            <Outlet/>
        </React.Fragment>
    )

}